import { render, staticRenderFns } from "./StatusLight.vue?vue&type=template&id=643398fb&"
import script from "./StatusLight.vue?vue&type=script&lang=js&"
export * from "./StatusLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports